import { useRef, useState } from 'react';
import Chrevon from '../../svg/ChevronLeft15.svg';
import styles from './GroupingDropdown.module.css';
import { getPrizeGroupingInfo, PrizeGroupingInfo } from './PrizeGroupings';

export const GroupingDropdown = (props: {
  filterType: 'tier' | 'category';
  selectedFilter: PrizeGroupingInfo | string | undefined;
  setSelectedFilter: (filter: string | undefined) => void;
}) => {
  const filters = getPrizeGroupingInfo(props.filterType);

  const [filterOpen, setFilterOpen] = useState(false);
  const [filterSelected, setFilterSelected] = useState<
    undefined | PrizeGroupingInfo
  >(
    filters.find((x) =>
      typeof props.selectedFilter === 'string'
        ? props.selectedFilter === x.code
        : props.selectedFilter?.code === x.code,
    ),
  );
  const filterRef = useRef<HTMLDivElement>(null);

  return (
    <div
      className={`${styles.filterSelectLabel} ${styles.filterOnly} ${filterOpen ? styles.backgroundDim : ''}`}
      ref={filterRef}
      onClick={(e) =>
        filterOpen &&
        e.currentTarget == filterRef.current &&
        setFilterOpen(false)
      }
    >
      <button
        className={`${styles.selectButton} ${filterOpen ? styles.filterOpen : styles.filterClosed}`}
        onClick={(e) => {
          e.preventDefault();
          setFilterOpen((prev) => !prev);
        }}
      >
        <span
          className={`${styles.selectValue} ${filterSelected ? styles.filterSelected : ''}`}
        >
          {filterSelected ? (
            <>
              {filterSelected.title}
              {filterSelected.subtitle && <em>{filterSelected.subtitle}</em>}
            </>
          ) : props.filterType === 'tier' ? (
            'Tiers'
          ) : (
            'Categories'
          )}
        </span>
        <Chrevon />
      </button>
      <ul
        id="filter-input"
        className={`${styles.filterInput} ${filterOpen ? styles.filterOpen : styles.filterClosed}`}
      >
        {filterSelected && (
          <li className={styles.filterButtonContainer}>
            <button
              onClick={() => {
                setFilterOpen(false);
                setFilterSelected(undefined);
                props.setSelectedFilter(undefined);
              }}
              className={`${styles.filterButton} ${styles.filterButtonClear}`}
            >
              <div className={styles.image}>
                <img
                  src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                  alt=""
                />
              </div>
              <div className="aboutUsTypographyHeaderMedium">View all</div>
            </button>
          </li>
        )}
        {filters.map((item, i) => {
          return (
            <li className={styles.filterButtonContainer} key={i}>
              <button
                onClick={() => {
                  setFilterOpen(false);
                  setFilterSelected(item);
                  props.setSelectedFilter(item.code);
                }}
                className={styles.filterButton}
              >
                <div className={styles.image}>{item.imageElement}</div>
                <div>
                  <div className="aboutUsTypographyHeaderMedium">
                    {item.title}
                    {item.subtitle && <em>{item.subtitle}</em>}
                  </div>
                  <div>{item.description}</div>
                </div>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
